import React from "react";
import Parallax2 from "../common/parallax/Parallax2";
import Map from "./map/Map";
import TopContactSection1 from "./section1/TopContactSection1";
import BottomContactSection2 from "./section2/BottomContactSection2";

const Contact = () => {
  return (
    <>
      <Parallax2 heading="CONTACT " subHeading="HOME /CONTACT US" />
      <TopContactSection1 />
      <BottomContactSection2 />
      {/* <Map/> */}
    </>
  );
};

export default Contact;
